import { Component, effect, inject, input, Input, signal, untracked } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HandelsgeschaeftTyp, InterestCalculationType, SimpleHgType } from 'lion-api';
import { CustomerStore, TradeTransactionStore, UserStore } from '@shared/data';

@Component({
  selector: 'app-form-zins',
  standalone: false,
  templateUrl: './form-zins.component.html',
  styleUrl: './form-zins.component.scss'
})
export class FormZinsComponent {
  @Input() attachForm?: FormGroup;
  @Input() renderZinsperiodeFeld?: boolean;
  @Input() renderNachverzinsungFeld?: boolean;
  @Input() renderFesterZinsFeld?: boolean;
  @Input() tagesgeldMitBestand?: boolean;
  @Input() korrektur?: boolean;
  @Input() storno?: boolean;
  @Input() renderHeader = true;
  @Input() isDzUser?: boolean;
  @Input() availableMethods?: InterestCalculationType[];
  @Input() tradeTransactionType?: SimpleHgType;

  hasInterestRate = input(true);
  hasGeschInterestRate = input(true);

  get isAnlageCallMoney(): boolean {
    return (
      this.tradeTransaction().typ?.richtung === HandelsgeschaeftTyp.RichtungEnum.Anlage &&
      this.tradeTransaction().typ?.simpleHgType === SimpleHgType.Tagesgeld
    );
  }

  protected tradeTransactionStore = inject(TradeTransactionStore);
  protected userStore = inject(UserStore);
  protected customerStore = inject(CustomerStore);
  protected tradeTransaction = this.tradeTransactionStore.tradeTransaction;
  protected isInterestLoading = this.tradeTransactionStore.isInterestRateLoading;

  protected isInterestMethodSelectable = signal(true);

  get showZinsperiodeFeld(): boolean {
    const isCorporateCustomer = this.customerStore.isCorporate() || this.tradeTransaction().kunde?.type === 'FIRMENKUNDE';
    const isTagesgeld = this.tradeTransaction().typ?.simpleHgType === SimpleHgType.Tagesgeld;

    if (isCorporateCustomer && isTagesgeld) {
      return true;
    }
    return !!this.renderZinsperiodeFeld;
  }

  get isZinsperiodeSelectable(): boolean {
    const isFkTrader = this.userStore.isFkTrader();
    const isFkDzTrader = this.userStore.isFkDzTrader();
    const isCorporateCustomer = this.customerStore.isCorporate() || this.tradeTransaction().kunde?.type === 'FIRMENKUNDE';
    const isTagesgeld = this.tradeTransaction().typ?.simpleHgType === SimpleHgType.Tagesgeld;

    if (isCorporateCustomer && isTagesgeld && (isFkTrader || isFkDzTrader)) {
      return false; // Always readonly for corporate customers when using these trader roles
    }
    return this.isInterestMethodSelectable();
  }

  protected readonly SimpleHgType = SimpleHgType;
  protected interestPeriodeType: string[] = ['EUR  LDM      F', 'EUR  FDM      F', 'EUR   W 1/MON F', 'EUR   W 5/FRI F'];

  constructor() {
    effect(() => {
      const tradeTransaction = this.tradeTransaction();

      untracked(() => {
        const tradeTransactionType = tradeTransaction.typ;
        const currentBalance = tradeTransaction.aktuellerBestand;

        if (Object.keys(tradeTransaction).length === 0) {
          this.isInterestMethodSelectable.update(() => false);
        }

        if (currentBalance != null && tradeTransactionType != null && tradeTransactionType.simpleHgType == SimpleHgType.Tagesgeld) {
          this.isInterestMethodSelectable.update(() => currentBalance === 0);
        } else {
          this.isInterestMethodSelectable.update(() => true);
        }
      });
    });
  }
}
